// extracted by mini-css-extract-plugin
export var askAiIcon = "_nb-j";
export var category = "_nb-9";
export var categoryHeader = "_nb-e";
export var container = "_nb-0";
export var group = "_nb-a";
export var groupItems = "_nb-f";
export var groupSeparator = "_nb-k";
export var loading = "_nb-1";
export var noResults = "_nb-3";
export var placeholder = "_nb-2";
export var resultContent = "_nb-5";
export var resultIcon = "_nb-c";
export var resultItem = "_nb-g";
export var resultMeta = "_nb-8";
export var resultSubtitle = "_nb-7";
export var resultSuffix = "_nb-i";
export var resultTitle = "_nb-6";
export var resultsList = "_nb-4";
export var searchGroup = "_nb-d";
export var selected = "_nb-h";
export var subgroup = "_nb-b";